import { useState } from "react";
import { Link } from "react-router-dom";
import TableAttendance from "../../components/table/TableAttendance";
import ModalExportAttendance from "../../components/modal/ModalExportAttendance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDay,
  faFileExport,
  faPlus,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-bootstrap";

import { tr } from "../../i18n";
const TabAttendance = () => {
  const [showExportModal, setShowExportModal] = useState(false);

  return (
    <div>
      <Row>
        <Col lg={12} className="mb-4 mt-3">
          <Row>
            <Col lg={12}>
              <div className="d-flex gap-3 justify-content-end">
                <button
                  type="button"
                  onClick={() => setShowExportModal(true)}
                  className="btn btn-outline-primary d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm fw-small"
                >
                  <FontAwesomeIcon icon={faFileExport} />
                  {tr("attendance:export_attendance")}
                </button>

                <Link
                  to="/attendance/import"
                  className="btn btn-outline-primary d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm fw-small"
                >
                  <FontAwesomeIcon icon={faUpload} />
                  {tr("attendance:import_attendance")}
                </Link>

                <Link
                  to="/attendance/new"
                  className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm fw-small"
                >
                  <FontAwesomeIcon icon={faPlus} />
                  {tr("attendance:add_attendance")}
                </Link>
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={12}>
          <TableAttendance />
        </Col>
      </Row>

      <ModalExportAttendance
        show={showExportModal}
        onClose={() => setShowExportModal(false)}
      />
    </div>
  );
};

export default TabAttendance;
